import { isPermittedRoute } from './utils';

import type { UserRole } from 'applications/GSP/shared/types';
import type { LinkProps } from 'react-router-dom';

export function getNavigationItemsByRole<Route extends LinkProps>(
  role: UserRole,
  routes: Route[],
) {
  return routes.filter(route => isPermittedRoute(role, route.to));
}
